import {IntermediatePart} from "../../parts/intermediatePart";
import {getFeatureIsLocked} from "../../../../../misc/helpers";
import store from "../../../../../store";
import {toggleNotCompatibleView} from "../../../../../actions/selectionFunctions";
import DesignNavigationItem from "../../../../visComponents/designNavigationItem";

export default class TubCommon extends IntermediatePart {

  constructor(isChild) {
    super(isChild);
  }

  navigationSubItems(filters, searchText) {
    const filteredAvailableFeatures = super.getFeaturesBySearchText(super.getFilteredFeaturesByFilters(filters), searchText);
    const featuresToDisplay = super.navigationSubItemsWithFilterMultipleConditions(this.getArrayOfConditions(), filteredAvailableFeatures);
    return featuresToDisplay.map(_ => new DesignNavigationItem(_.featureName, _));
  }

  disabledClick() {}

  applyFeatureIfNotCompatible() {
    const showerTubComboParent = this.getParent().getParent();
    showerTubComboParent.setShowerTubCombo();
    showerTubComboParent.setActiveTub(this.partId);
  }

  handleClick(ignoreLocked) {
    super.handleClick(ignoreLocked);

    if (this.notAvailableInVisualizer || getFeatureIsLocked(this)) {
      return
    }

    const showerTubComboParent = this.getParent().getParent();
    const currentBottomTub = showerTubComboParent.bottomTub;

    const showNotCompatibleViewConditions = !window.location.hash.includes("visualizer") &&
      (!showerTubComboParent.showerTubComboIsActive || (
        (this.partId === "walk_in_tub" && currentBottomTub !== "walk_in_tub") || (this.partId !== "walk_in_tub" && currentBottomTub === "walk_in_tub")
      ));

    if (showNotCompatibleViewConditions) {
      store.dispatch(toggleNotCompatibleView(true));
      return;
    }

    this.applyFeatureIfNotCompatible();
    this.featureClicked();
  }

  getArrayOfConditions() {
    const showerSize = this.getParent().showerSize();
    return [{
      propName: 'ShowerSize',
      propValue: showerSize
    }];
  }

  setLayers(layout) {
    if (this.getParent().bottomTub !== this.partId) {
      super.hideLayers();
      return;
    }
    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions())
      || (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      return super.setLayers(layout);
    }

    this.setDefault();
    return super.setLayers(layout);
  }

}
